export default __webpack_public_path__ + "static/media/byimin.85d1a7bc.png";